module.exports = __webpack_public_path__ + "static/piercer-d9abcd68783a3f7a7cd801274f56e488.jpeg";